function addUpsellProduct(btnObj){
     const vID = btnObj.attr("data-vid");
      var addData = {
          'id': vID, 
          'quantity': 1
        };
      
      // add new product
      fetch('/cart/add.js', {
        body: JSON.stringify(addData),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
        },
        method: 'POST'
      }).then(function(response) {
        return response.json();
      }).then(function(json) {
        updateCart();
      }).catch(function(err) {
        /* uh oh, we have error. */
        console.error(err)
      });
 } 

function updateCart(){
  $.ajax({
      url: '/cart?view=ajax-cart',
      type: 'GET',
      dataType: 'html',
      success: function(data) {
        $("cart-drawer-items").html($(data).find("cart-drawer-items").html());
        $(".drawer__footer").html($(data).find(".drawer__footer").html());
        $("cart-drawer").removeClass("loading");
      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.error("Error fetching line-item-list content:", errorThrown);
      }
    });
}

$(document).on("click", ".shipping-protection-cover button.upsell__toggle-switch", function(){
  var isProtectionAdded = $(this).parents("cart-drawer-upsell").attr("data-selected");
  if(isProtectionAdded == "false"){
    $(this).parents("cart-drawer-upsell").find(".product-form__submit").click();
    $(this).parents("cart-drawer-upsell").attr("data-selected", "true");
  }else{
    $(".cart-item.item-shipping-protection .cart-remove-button").trigger("click");
    $(this).parents("cart-drawer-upsell").attr("data-selected", "false");
  }
});

$(document).on("click", ".cart-drawer-upsells-container button.upsell__add-btn", function(){
  $(this).parents("cart-drawer-upsell").find(".product-form__submit").click();
  $(this).parents("cart-drawer-upsell").slideUp();
});

